import { useQuery } from "@tanstack/react-query";
import { API } from "../data/site";
import { CATEGORIES as FALLBACK } from "../data/products";

export const useProducts = () =>
  useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const res = await fetch(`${API}/products`);
      if (!res.ok) throw new Error("Failed to load products");
      const data = await res.json();
      return data.products?.length ? data.products : FALLBACK;
    },
    initialData: FALLBACK,
    staleTime: 30_000,
  });
